
/*==================================
=         TRAFFIC OVERVIEW        =
==================================*/
Vue.component('traffic_overview', {
    template:'#trafficoverview-template',
    data:function(){
        return{
            list: [],
            searchString:'',
            moment:moment,
            modal:'',
            tasks:[],
            acceptedTasks:[],
            productionDivisions:[],
            currentUser:{},
            productionDivisionMembers:{},
            activeMember:{},
            closestBusinessDay:{},
            opened_task: null,
            opened_ticket_without_task: null,
            hour: 0,
            widget: {
                coordinates: {
                    x: null,
                    y: null
                },
                ticket:{},
                color: 'red'
            }
        };
    },
    created:function(){
        showLoadingOverlay();
        vex.defaultOptions.className="vex-theme-flat-attack";
        $('.sidebar').fadeOut();
        activeInstance = this;

        activeInstance.getProductionDivisions();
        activeInstance.getCurrentUser();

        setTimeout( activeInstance.getClosestBusinessDay(), 1000);


        $(document).click(function (e) {
            e.stopPropagation();
            var container = $(".task.create");

            if (container.has(e.target).length === 0) {
                console.log(1);
                activeInstance.opened_ticket_without_task = null;
            }
        });

        $(document).click(function (e) {
            e.stopPropagation();
            var container = $(".task");

            if (container.has(e.target).length === 0) {
                console.log(2);
                activeInstance.opened_task = null;
            }
        });
    },
    methods: {
        openTicket: function(id) {
            activeInstance.opened_ticket_without_task = id;
            activeInstance.opened_task = null;
        },
        openTask: function(id) {
            activeInstance.opened_task = id;
            activeInstance.opened_ticket_without_task = null;
        },
        closeWidgets: function() {
            activeInstance.opened_task = null;
            activeInstance.opened_ticket_without_task = null;
        },
        inputClicked: function(event) {
            var elem = $(event.target),
                focused = elem.data("focused");

            console.log(focused);

            if (focused == "true") {
                return;
            }

            elem.select();
            elem.data("focused", "true")
        },
        changedInput: function(event) {
            var input = $(event.target);

            var step = parseInt(input.attr("step"), 10),
                min = parseInt(input.attr("min"), 10),
                val = parseInt(input.val(), 10),
                max = parseInt(input.attr("max"), 10);

            if (val > max) {
                input.val(max);
                return;
            }

            if (val < min) {
                input.val(min);
                return;
            }

            if (val % step != 0) {
                input.val(val - (val % step));
                return;
            }
        },
        getClosestBusinessDay:function(){

          axios.get(baseURL+'/api/traffic/closest_business_day')
              .then(function(response){
                    activeInstance.closestBusinessDay = response.data;

                    setTimeout(function(){
                      activeInstance.initializeCalendars();
                    },1000);

              })
              .catch(function(error){

              });
        },
        acceptTask: function(task) {

            // ACCEPT TASK

            this.closeWidgets();
        },
        initializeCalendars:function(){
            console.log('initializing calendars');
            for(var i = 0 ; i < activeInstance.productionDivisionMembers.length; i ++) {
                $('#calendar_'+activeInstance.productionDivisionMembers[i].id).fullCalendar({
                    height: 510,
                    weekends: true,
                    defaultView: 'agendaWeek',
                    defaultDate:  moment(activeInstance.closestBusinessDay.date).startOf('week').add(i, 'days'),
                    events: activeInstance.productionDivisionMembers[i].tasks,
                    firstHour:8,
                    minTime:'08:00',
                    maxTime:'20:00',
                    businessHours: {
                        // days of week. an array of zero-based day of week integers (0=Sunday)
                        dow: [ 1, 2, 3, 4, 5, 6 ], // Days of the week
                        start: '09:00', // a start time (10am in this example)
                        end: '18:00', // an end time (6pm in this example)
                    },
                    header:{
                        left:   '',
                        center: '',
                        right:  ''
                    },
                    showNonCurrentDates: true,
                    eventClick: function(calEvent, jsEvent, view) {
                        console.log({calEvent, jsEvent, view});

                        activeInstance.widget.coordinates = {x: $(this).width() + $(this).offset().left, y: $(this).offset().top};
                        activeInstance.widget.ticket = calEvent.ticket;
                    }
                });
            }
        },
        getCurrentUser: function () {
            axios.get(baseURL + '/api/user/info').then(function (response) {
                activeInstance.currentUser = response.data;
            });
        },
        getProductionDivisions: function () { //wuz /api/traffic/production_division_members
            Vue.http.get(baseURL + '/api/traffic/todo/list/production_division_members', function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.productionDivisions = response;
                activeInstance.productionDivisionMembers = response;
                setTimeout(function () {
                    activeInstance.setActiveMember();
                }, 400);
            }).bind(this);
        },
        setActiveMember: function () {
            activeInstance.productionDivisionMembers.forEach(function(member){
                console.log(member);
                if(activeInstance.currentUser.id == member.id){
                    activeInstance.activeMember = member;
                }
            });
        },
        cancelPick:function(task){
            vex.dialog.confirm({
                message: 'Biztosan visszavonod?',
                callback: function (data) {
                    if (!data) {
                        console.log('Cancelled')
                    } else {
                        axios.post(baseURL+'/api/traffic/task/cancel',{
                            'task_id':task.id
                        })
                            .then(function(response){

                                task = response.data.updated_data;

                            });

                        //TODO::UPDATE THE TASK ACCORDING TO THE SERVER RESPONSE (SHOULD BE VISIBLE IN THE CALENDAR AFTER THIS)


                    }
                }
            });
        },
        strip: function(html) {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        pickTask:function(task){
            //ASK FOR ESTIMATED DURATION
            vex.dialog.open({
                message: 'Mennyi időt vesz igénybe várhatóan?',

                input: [
                    '<input style="width:100px;display:inline-block;" name="hours" type="number" placeholder="óra"   step="1" min="0" max="24" required />',
                    '<div style="display:inline-block;margin-left:5px;margin-right:5px;">:</div>',
                    '<input style="width:100px;display:inline-block;" name="minutes" type="number" placeholder="perc" step="5" min="0" max="55" required />',
                ].join(''),
                buttons: [
                    $.extend({}, vex.dialog.buttons.YES, { text: 'Felveszem' }),
                    $.extend({}, vex.dialog.buttons.NO, { text: 'Vissza' })
                ],
                callback: function (data) {
                    if (!data) {
                        console.log('Cancelled')
                    } else {
                         var duration_minutes = (parseInt(data.minutes)) + ( parseInt(data.hours) * 60);
                         console.log(duration_minutes);

                        //TODO::FIND THE NEXT SPOT TO PLACE THE TASK (POST TO THE SERVER TO SORT IT OUT)

                        axios.post(baseURL+'/api/traffic/task/dispatch',{
                            'task_id':task.id,
                            'estimated_duration':duration_minutes * 60
                        })
                        .then(function(response){
                            console.log(response.data);
                            task.start = response.data.updated_data.start;
                            task.status = response.data.updated_data.status;

                        });

                        //TODO::UPDATE THE TASK ACCORDING TO THE SERVER RESPONSE (SHOULD BE VISIBLE IN THE CALENDAR AFTER THIS)

                    }
                }
            });
        }
    }
});